import { DestinationsView } from '@/components/destinations/destinations-view'
import { createFileRoute, redirect } from '@tanstack/react-router'

export const Route = createFileRoute('/_app/dashboard_/destinations')({
  component: RouteComponent,
  beforeLoad: ({ context: { user } }) => {
    if (user?.isAdmin) throw redirect({ to: '/sign-out' })
    return { breadcrumb: 'Destinations' }
  }
})

function RouteComponent() {
  const { user, orpc } = Route.useRouteContext()

  return <DestinationsView user={user} orpc={orpc} />
}
